'use client';

import { IconButton, Tooltip } from '@coolblue-development/freddy';
import { Copy } from '@coolblue-development/icons';
import { useState } from 'react';

type Props = {
  contentToCopy: string;
  tooltipDescription: string;
};

export const CopyButton = ({ contentToCopy, tooltipDescription }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip description={tooltipDescription} open={open} placement='right'>
      <IconButton
        iconColor='inverse'
        sx={{ padding: 0 }}
        onClick={() => {
          navigator.clipboard.writeText(contentToCopy);
          setOpen(true);
          setTimeout(() => {
            setOpen(false);
          }, 2000);
        }}
        aria-label='Copy email address'
      >
        <Copy />
      </IconButton>
    </Tooltip>
  );
};
